import { clearFilterParams, useCleanFilterForRequest } from '@btime/react-contexts'
import { gql } from '@apollo/client'
import { mergeDeepLeft, pick } from 'ramda'
import React from 'react'

import { placesClient } from '../../../../../../utils/apollo/api'
import { useQuery } from '../../../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../../../packages/kiti/components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const usePlacesCounterState = () => React.useContext(Context)
export const usePlacesCounter = () => usePlacesCounterState()?.placesCount
export const useAllPlacesCounter = () => usePlacesCounterState()?.all

const QUERY = gql`
  query PlacesCount($filter: PlaceFilter, $fixedFilter: PlaceFilter) {
    placesCount(filter: $filter)
    all: placesCount(filter: $fixedFilter)
  }
`

const PlacesCounterLoader = ({ widget, children }) => {
  const widgetFilter = clearFilterParams(widget.data?.filters || []) || {}
  const ignoreDate = widget?.data?.ignoreDate
  const { date, ...manualFilter } = pick(['date', 'placeLevelIds'], useCleanFilterForRequest() || {})
  const insertedAt = !ignoreDate ? date : undefined
  const fullFilter = mergeDeepLeft(widgetFilter, manualFilter)

  const { data, ...state } = useQuery(QUERY, {
    variables: { filter: { ...fullFilter, insertedAt }, fixedFilter: { ...manualFilter, insertedAt } },
    client: placesClient
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default PlacesCounterLoader
